import React from 'react';
import { EmailTemplatesEditTemplate } from 'themes/application/email-templates/pages';
import { observer } from 'mobx-react';
import { EmailTemplatesEditViewStore } from 'application/email-templates/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new EmailTemplatesEditViewStore(rootStore), 'emailTemplatesEditViewStore')
@observer
class EmailTemplatesEdit extends React.Component {
    render() {
        return <EmailTemplatesEditTemplate {...this.props} />
    }
}

export default EmailTemplatesEdit;
